import { IDeserialize } from "./abstraction/IDeserialize";
import { Department } from "./Department";

export class Company implements IDeserialize<Company> {
  /*
   * List of departments user belongs to
   */
  departments: Department[];

  /*
   * List of all company departments
   */
  departmentList: Department[];

  /*
   * Currently selected department (null or empty if no department set)
   */
  department: Department;

  /** Region where the company is retrieved (to which region it belongs). */
  region: string;

  constructor(
    public fullName?: string,
    public name?: string,
  ) {
    this.departments = [];
    this.department = null;
  }

  deserialize(model: Company): this {
    if (!model) return this;
    Object.assign(this, model);
    this.departmentList = this.departmentList?.map((x) => new Department().deserialize(x));
    this.department = new Department().deserialize(this.department);
    this.departments = this.departments?.map((x) => new Department().deserialize(x));
    return this;
  }
}
